import React, {useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import { useSelector } from 'react-redux';
import t from '../../i18n/translate'
import {
  CartWrapper,
  Cart,
  CartTitle,
  ProductImage,
  CartBodyWrapper,
  CartFooterWrapper,
  ProductDescription,
  CartButton,
  ProductPriceWrapper,
  ProductPrice,
  PromoPrice
} from "./ProductOfTheWeekCart.style";
import expressService from "../../services/expressService";
import { compDate } from "../../constants/Constant";
import { CURRENCY } from "../../helper/constant";
import { Spinner} from 'react-bootstrap';
import {useCart} from '../../contexts/cart/use-cart'
import { QuantityModifier } from "../QuantityModifier/QuantityModifier";
import ReadMore from "../../components/Truncate/Truncate";
import itemToCartService from '../../services/itemToCartService';
import {CartBuy} from "../AllSvgIcon";
import SimpleMessageDialog from '../SimpleMessageDialog/SimpleMessageDialog';
import { logAddToCart, logPageView, logRemoveFromCart, logViewItem } from '../../services/googleAnalytics';
import LazyLoad from "react-lazyload";

const ProductOfTheWeekCart = (item) => {
  const params = useLocation();
  const isAdmin = (params.pathname.split("/")[1] === 'admin') ? true :false
  const {
    getItem,
    isInCart,
    resetCart,
    fetchOrderItems,
  } = useCart();
  const cartType = useSelector(state => state.cartReducer.cartType);
  let history = useHistory();
  // Simple Message Dialog
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showHeaderDialog, setShowHeaderDialog] = useState(false);
  const [isConfirmButton, setIsConfirmButton] = useState(false);
  const [confirmLabel, setConfirmLabel] = useState('OK');
  const [dialogLoading, setDialogLoading] = useState(false);
  const [closeLabel, setCloseLabel] = useState('CLOSE');
  const [dialogHeaderLabel, setDialogHeaderLabel] = useState('Error');
  const [errorLog, setErrorLog] = useState(null);
  const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
  
  // Update quantity
  const [isLoading, setIsLoading] = useState(false);


  const handleAddClick = async (e) => {
    e.stopPropagation();

    setSimpleDialogBackdrop(true);

    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
      document.getElementById("joinBTn").click(); //onCartClick();
      window.trigger = "add to cart"
    } else {
      let itemQuantity = 1;
      setIsLoading(true);
      // If user click on button [Add to cart]
      if (isInCart(item.product.item_id)) {
        itemQuantity = getItem(item.product.item_id).quantity + 1;
      }

      const itemResp = await itemToCartService.addItem(item.product.item_id, cartType, itemQuantity);
      if(itemResp.success) {
        fetchOrderItems(cartType);
        logAddToCart(itemResp.data)
      }
      else {
        if(typeof itemResp.error === 'string' && itemResp.error === "multiSupplier") {
          setIsConfirmButton(true);
          setConfirmLabel( t('shop_add_item_to_cart_different_shop_error_remove') );
          setCloseLabel( t('shop_add_item_to_cart_different_shop_error_cancel') );
          setDialogHeaderLabel( t('shop_add_item_to_cart_different_shop_error_title') )
          setShowHeaderDialog(true);
          setErrorLog({
            error: true,
            error_type: 'multiSupplier'
          });
        }
        else if(itemResp.error && itemResp.data.type === "paymentInProgress") {
          setIsConfirmButton(true);
          setConfirmLabel( t('shop_popup_continue_payment_button') );
          setCloseLabel( t('shop_popup_cancel_payment_button') );
          setDialogHeaderLabel( t('shop_popup_payment_locked_label') )
          setShowHeaderDialog(true);
          setErrorLog({error: true, error_type: 'paymentInProgress'});
          setSimpleDialogBackdrop('static')
        }
        else {
          setErrorLog({error: false});
        }
        setErrorMessage(itemResp.message);
        setShowError(true);
      }
      setIsLoading(false);
    }
  };

    // Simple Dialog
  const closeSimpleDialog = async () => {
    if(errorLog.error && errorLog.error_type === 'paymentInProgress') {
      setDialogLoading(true);
      const orderLockResp = await expressService.orderLocked(cartType);
      if(orderLockResp.status === 200) {
        setTimeout(async () => {
          const itemResp = await itemToCartService.addItem(item.item_id, cartType);

          if(itemResp.success) {
            logAddToCart(itemResp.data)
            await fetchOrderItems(cartType);
          }
          else {
            setErrorMessage(itemResp.message);
          }

          setShowError(false);
          setDialogLoading(false);
        }, 250);
      }
      else {
        alert( t('shop_item_update_error') );
        setShowError(false);
        setDialogLoading(false);
      }
    }
    else {
      setShowError(false);
    }
  }
  const onConfirm = () => {
    if(errorLog.error && errorLog.error_type === 'multiSupplier') {
      handleOverWriteCart();
    }
    else if(errorLog.error && errorLog.error_type === 'paymentInProgress') {
      window.location.href = '/checkout'
    }
  }
  const handleOverWriteCart = async () => {
    setDialogLoading(true);

    await resetCart();

    setTimeout(async () => {
      const itemResp = await itemToCartService.addItem(item.item_id, cartType);

      if(itemResp.success) {
        await fetchOrderItems(cartType);
      }
      else {
        setErrorMessage(itemResp.message);
      }

      setShowError(false);
      setDialogLoading(false);
    }, 250);
  };

  const handleRemoveClick = async (e) => {
    e.stopPropagation();
    let itemResp = null;

    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
      document.getElementById("joinBTn").click(); //onCartClick();
      window.trigger = "add to cart"
    }
    else{
      setIsLoading(true);
      // Remove item from cart When user click on button decrease item quantity <= 1
      if (getItem(item.product.item_id).quantity === 1) {
        itemResp = await itemToCartService.removeItemFromCart(getItem(item.product.item_id), cartType);
        logRemoveFromCart(item.product,1)
      }
      // When user click on button decrease item quantity
      else {
        itemResp = await itemToCartService.addItem(item.product.item_id, cartType, getItem(item.product.item_id).quantity - 1);
        logRemoveFromCart(itemResp.data,0)
      }

      if(itemResp.success) {
        fetchOrderItems(cartType);
      }
      else {
        setShowError(true);
        setErrorMessage(itemResp.message);
      }
      setIsLoading(false);
    }
  };

  const handleCardClick = () => {
    logPageView(`/product/${item.product.item_ref_id}`)
    logViewItem(item.product,(`/product/${item.product.item_ref_id}`))
    history.push(`/product/${item.product.item_ref_id}`);
    window.scrollTo(0, 0);
  }

  /**
              * Function to get the brand name or slug from the item object.
              *
              * @param {Object} item - The item object containing brand information.
              * @param {string} [type="name"] - The type of information to retrieve ("name" or "slug").
              * @returns {string|null} - The name or slug of the first brand in the list, or null if no brands are available.
              */
             const brandName = (item, type = "name") => {
               if (item.list_brands) {
                   switch (type) {
                       case "name": {
                           return item?.list_brands[0]?.name;
                       }
                       case "slug": {
                           return item?.list_brands[0]?.brand_ref_id;
                       }
                       default: return null;
                   }
               }
               return null;
             }
  return (
    <>{
      Object.keys(item).length === 0 ? (
        <CartWrapper>
          <Cart>
            <CartTitle>
              {t("home_product_of_the_week_label")}
            </CartTitle>
            <ProductImage>
              <LazyLoad>
                <img
                  src="https://delishop.s3-ap-southeast-1.amazonaws.com/product/XIAOMI143.jpg"
                  alt=""
                />
              </LazyLoad>
            </ProductImage>
            <CartFooterWrapper>
              {/* <p className="product_name" style={{ fontWeight: "bold" }}>Australian Choice Cavendish Bananas</p> */}
              <p className="product_name">Australian Choice Cavendish Bananas</p>
              {/* <ProductStar>
                <GradeIcon />
                <GradeIcon />
                <GradeIcon />
                <GradeIcon />
                <GradeIcon />
              </ProductStar> */}
              <div className='product_price'>
                <p className="dis_price">$299.00</p>
                <p className="p_price">$299.00</p>
              </div>
              <ProductDescription>
                Waranty 6 Months, Battery type: Lithium-ion polymer battery Battery power: 74 Wh/3.7 V/20,000 mAh Rated capacity: 12,000 mAh
              </ProductDescription>
              <CartButton>{t("button_add_to_cart")}</CartButton>
            </CartFooterWrapper>
          </Cart>
        </CartWrapper>
      ) : (
            <CartWrapper>
              <Cart onClick={handleCardClick}>
                <a href={`/product/${item.product.item_ref_id}`} style={{textDecoration:"none", all:"unset"}}>
                    <CartTitle>
                      {t("home_product_of_the_week_label")}
                    </CartTitle>
                    <ProductImage>
                      <img
                        src={item.product.default_image_url}
                        alt="product"
                        fetchpriority="high"
                        loading="eager"
                        decoding="async"
                      />
                    </ProductImage>
                    <CartBodyWrapper>
                      <h3 className="product_name">{item.product.name} <><a href={`/brand/${brandName(item.product,"slug")}`} style={{color:"#000000", textDecoration:"none"}} onClick={(e) => e.stopPropagation()}
                      >{brandName(item.product) && ("- " + brandName(item.product))}</a></></h3>
                      {/* <ProductStar>
                        <GradeIcon />
                        <GradeIcon />
                        <GradeIcon />
                        <GradeIcon />
                        <GradeIcon />
                      </ProductStar> */}
                      {/* <div className='product_price'>
                        <p className="dis_price">$299.00</p>
                        <p className="p_price">$299.00</p>
                      </div> */}
                      <ProductPriceWrapper className={item.product.promoProduct && "promo-price"}>
                        {item.product.price !== item.product.store_items_price_types[0].price && (
                          <ProductPrice className={item.product.promo === 1 && item.product.promo_start_date !== null && item.product.promo_end_date !== null && compDate(item.product.promo_start_date, item.product.promo_end_date) ? `strike-through` : ""}>
                            {/* <SalePrice> */}
                            <meta itemProp={"oldPriceCurrency"} content={"USD"} />
                            <span itemProp={"oldPrice"}
                              content={parseFloat(item.product.store_items_price_types[0].price).toFixed(2)}
                              className={`${item.product.promoProduct ? "promo-price" : ""}`}
                            >{CURRENCY}{parseFloat(item.product.store_items_price_types[0].price).toFixed(2)}</span>
                            {/* </SalePrice> */}
                          </ProductPrice>
                        )}
                        {item.product.promo === 1 && item.product.promo_start_date !== null && item.product.promo_end_date !== null && compDate(item.product.promo_start_date, item.product.promo_end_date) && (
                          <PromoPrice className={item.product.promoProduct ? "promo-price" : ""} itemscope itemtype="https://schema.org/PriceSpecification">
                            {/* <SalePrice> */}
                            <meta itemProp={"@type"} content={"UnitPriceSpecification"} />
                            <meta itemProp={"priceType"} content={"https://schema.org/ListPrice"} />
                            <meta itemProp={"priceCurrency"} content={"USD"} />
                            <span itemProp={"price"}
                              content={parseFloat(item.product.promo_price).toFixed(2)}
                              className={`${compDate(item.product.promo_start_date, item.product.promo_end_date) ? "promo-price" : ""}`}
                            >{CURRENCY}{parseFloat(item.product.promo_price).toFixed(2)}</span>
                            <meta itemProp="priceValidUntil" content={item.product.promo_end_date} />
                            {/* </SalePrice> */}
                          </PromoPrice>
                        )
                        }
                      </ProductPriceWrapper>
                      {item.product.about_item &&
                        <ProductDescription itemProp={"description"}>
                          <ReadMore character={1200}>
                            {item.product.about_item}
                          </ReadMore>
                        </ProductDescription>
                      }
                    </CartBodyWrapper>
                </a>
                <CartFooterWrapper>
                  {
                    !isAdmin ? (
                      <div className="product-country-and-btn">
                        {cartType !== "express"
                          ? !item.product.store_items_price_types[0].available_quantity  //outofstock
                            ? <div className={item.product.promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{t('shop_item_out_of_stock')}</div>
                            : !isInCart(item.product.item_id)
                              ?
                              // <Button colors="success"
                              //           className={item.product.promoPrice ? "btn btn-outline-success promo-cart-button "+"cart-button pr"+item.product.item_id : "btn btn-outline-success cart-button pr"+item.product.item_id}
                              //           // onClick={handleAddClick}
                              // >
                              <CartButton onClick={!isLoading && handleAddClick}>
                                {isLoading
                                  ? <Spinner animation="border" role="status" size="sm">
                                    <span className="sr-only">{t('toast_downloading')}</span>
                                  </Spinner>
                                  : <>
                                    <span className="cart-icon"><CartBuy /></span>
                                  </>
                                }{t('button_add_to_cart')}
                              </CartButton>
                              // </Button>
                              : <div onClick={(e) => e.stopPropagation()}>
                                <QuantityModifier
                                  className={`pr${item.product.item_id} ${cartType}`}
                                  value={getItem(item.product.item_id).quantity}
                                  onDecrement={handleRemoveClick}
                                  onIncrement={handleAddClick}
                                  // onUpdate={(quantity) => { handleInputUpdateQuantity(item.product,quantity) }}
                                  promoProduct={item.product.promoProduct}
                                  isLoading={isLoading}
                                />
                              </div>
                          : item.product.is_shop_open
                            ? !item.product.store_items_price_types[0].available_quantity  //outofstock
                              ? <div className={item.product.promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{t('shop_item_out_of_stock')}</div>
                              : !isInCart(item.product.item_id)
                                ?
                                // <Button colors="success"
                                //           className={item.product.promoProduct ? "btn btn-outline-success promo-cart-button "+"cart-button pr"+item.product.item_id : "btn btn-outline-success cart-button pr"+item.product.item_id}
                                //           // onClick={handleAddClick}
                                // >
                                <CartButton>
                                  {isLoading
                                    ? <Spinner animation="border" role="status" size="sm">
                                      <span className="sr-only">{t('toast_downloading')}</span>
                                    </Spinner>
                                    : <>
                                      <span className="cart-icon"><CartBuy /></span>{t('button_add_to_cart')}
                                    </>
                                  }
                                </CartButton>
                                // </Button>
                                : <div onClick={(e) => e.stopPropagation()}>
                                  <QuantityModifier
                                    className={`pr${item.product.item_id} ${cartType}`}
                                    value={getItem(item.product.item_id).quantity}
                                    onDecrement={handleRemoveClick}
                                    onIncrement={handleAddClick}
                                    // onUpdate={(quantity) => { handleInputUpdateQuantity(item.product,quantity) }}
                                    promoProduct={item.product.promoProduct}
                                    isLoading={isLoading}
                                  />
                                </div>
                            : !item.product.store_items_price_types[0].available_quantity  //outofstock
                              ? <div className={item.product.promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{t('shop_item_out_of_stock')}</div>
                              : null
                        }
                      </div>
                    ) : (<CartButton>{t("button_add_to_cart")}</CartButton>)
                  }
                </CartFooterWrapper>
              </Cart>
            </CartWrapper>
      )
    }
      <SimpleMessageDialog show={showError}
                           message={errorMessage}
                           showHeader={showHeaderDialog}
                           closeLabel={closeLabel}
                           confirmLabel={confirmLabel}
                           headerLabel={dialogHeaderLabel}
                           isConfirmButton={isConfirmButton}
                           onClose={closeSimpleDialog}
                           onConfirm={onConfirm}
                           backdrop={simpleDialogBackdrop}
                           loading={dialogLoading}
                           cartType={cartType}
      />
    </>
  );
}

export default ProductOfTheWeekCart
